<template>
	<div>
		<data-table
			title=""
			export-type='full'
			:columns="headers"
			:rows="$assignments"
			v-on:row-click="onShowInfo"
			class="m-data-table tw-mt-7 tw-w-full tw-overflow-auto scrollbar-x tw-rounded"
		>
			<template #[`item.actions`]="{ item }">
				<td>
					<b-button-group
						size="sm"
						class="tw-shadow-none"
					>
						<b-button variant="success">Update</b-button>
						<!-- @click="onInitUpdateItem(item)" -->
						<b-button
							variant="danger"
							@click="onDeleteItem(item)"
						>Delete</b-button>

					</b-button-group>
				</td>
			</template>
		</data-table>
		<modal-assignment-info @show="onShowInfo = $event" />
	</div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'

import DataTable from "vue2-matable"
import ModalAssignmentInfo from '../../components/Modals/ModalAssignmentInfo.vue'

export default {
	name: 'ClientAssignmentsTable',
	components: {
		DataTable,
		ModalAssignmentInfo
	},
	data: () => ({
		headers: [
			{ field: 'expert.name', label: 'Perito' },
			{ field: 'client', label: 'Cliente' },
			{ field: 'phone', label: 'Telefono' },
			{ field: 'town', label: 'Ciudad' },
			{ field: 'appraisalType', label: 'Tipo de Avaluo' },
			{ field: 'location.name', label: 'Ubicacion' },
			{ field: 'actions', label: 'Actions' },
		],

		// Functions
		onShowInfo: () => { },
	}),
	computed: {
		...mapGetters('assignments', [
			'$assignments'
		])
	},
	created() {
		this.subscribeAssignments()
	},
	methods: {
		...mapActions('assignments', [
			'subscribeAssignments'
		]),
		onDeleteItem(item) {
			if (confirm('Do you want to delete this item?')) {
				item.ref.delete()
			}
		},
	}
}
</script>
